// Scoring logic for Flow-Kurzskala (FKS)
// Based on Rheinberg, Vollmeyer & Engeser (2019)

export const calculateFlowScore = (answers) => {
  // Define question categories
  const absorptionQuestions = ['q1', 'q3', 'q4', 'q6', 'q10'];
  const fluencyQuestions = ['q2', 'q5', 'q7', 'q8', 'q9'];
  const worryQuestions = ['q11', 'q12', 'q13'];
  
  // Calculate subscale scores
  const absorption = calculateMean(answers, absorptionQuestions);
  const fluency = calculateMean(answers, fluencyQuestions);
  const worry = calculateMean(answers, worryQuestions);
  
  // Calculate total flow score (absorption + fluency, worry is separate)
  const flowCore = (absorption + fluency) / 2;
  
  // Total score considers all aspects
  const totalScore = (absorption + fluency - worry + 5) / 3; // Normalize worry impact
  
  // Challenge-skill balance
  const challenge = answers.q14 || 3;
  const skill = answers.q15 || 3;
  const fit = answers.q16 || 3;
  
  return {
    totalScore: Math.max(1, Math.min(5, totalScore)),
    absorption: absorption,
    fluency: fluency,
    worry: worry,
    flowCore: flowCore,
    challenge: challenge,
    skill: skill,
    fit: fit,
    balance: Math.abs(challenge - skill), // Lower is better (more balanced)
    answeredQuestions: Object.keys(answers).length
  };
};

const calculateMean = (answers, questionIds) => {
  const validAnswers = questionIds
    .map(id => answers[id])
    .filter(answer => answer !== undefined && answer !== null);
    
  if (validAnswers.length === 0) return 0;
  
  const sum = validAnswers.reduce((acc, val) => acc + val, 0);
  return sum / validAnswers.length;
};

// Interpretation helpers
export const getFlowLevel = (score) => {
  if (score >= 4.0) return 'Hoch';
  if (score >= 3.0) return 'Mittel';
  if (score >= 2.0) return 'Niedrig';
  return 'Sehr niedrig';
};

export const getFlowDescription = (score) => {
  if (score >= 4.0) {
    return 'Starkes Flow-Erleben - Sie waren vollständig in die Tätigkeit vertieft und haben optimale Leistungsbedingungen erlebt.';
  }
  if (score >= 3.0) {
    return 'Moderates Flow-Erleben - Sie haben eine gute Konzentration und Engagement in der Tätigkeit erfahren.';
  }
  if (score >= 2.0) {
    return 'Niedriges Flow-Erleben - Die Tätigkeit war möglicherweise nicht optimal herausfordernd oder interessant genug.';
  }
  return 'Sehr niedriges Flow-Erleben - Es gab wahrscheinlich Hindernisse oder die Tätigkeit passte nicht zu Ihren aktuellen Bedürfnissen.';
};

export const getChallengeSkillBalance = (challenge, skill) => {
  const difference = Math.abs(challenge - skill);
  
  if (difference <= 0.5) {
    return 'Optimal ausgewogen - Herausforderung und Fähigkeiten sind gut aufeinander abgestimmt.';
  }
  if (difference <= 1.0) {
    return 'Leicht unausgewogen - Kleine Anpassungen könnten das Flow-Erleben verbessern.';
  }
  if (challenge > skill) {
    return 'Überfordert - Die Anforderungen übersteigen Ihre Fähigkeiten deutlich.';
  }
  return 'Unterfordert - Ihre Fähigkeiten übersteigen die Anforderungen deutlich.';
};